import { render } from "./Crash.vue?vue&type=template&id=5936e7bb&scoped=true"
import script from "./Crash.vue?vue&type=script&lang=js"
export * from "./Crash.vue?vue&type=script&lang=js"

import "./Crash.vue?vue&type=style&index=0&id=5936e7bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5936e7bb"]])

export default __exports__